import {
  AutoComplete,
  AutoCompleteMulti,
  ISelectType,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { listMainGenerics } from "../../../../../../services/generic.service";
import { getInsuranceTypesList } from "../../../../../../services/tasyInsuranceType.service";
import { TDocumentForm } from "../esignRuleSchema";

const translationPath = "4uESign.page.automations.automationRules.";

const getHeaderFooterTypes = (_?: unknown) =>
  listMainGenerics({ Identifier: "EsignHeaderFooterType" });

interface IPrescriptionTypesFieldsProps {
  methods: UseFormReturn<TDocumentForm>;
}

export const PrescriptionTypesFields = memo(
  ({ methods }: IPrescriptionTypesFieldsProps) => {
    const { t } = useTranslation();
    const { getValues, setValue } = methods;
    const [prescriptionTypes, setPrescriptionTypes] = useState<ISelectType[]>(
      [],
    );
    const [headerFooterTypes, setHeaderFooterTypes] = useState<ISelectType[]>(
      [],
    );
    const { sendRequest: listPrescriptionTypes } = useFetch(
      getInsuranceTypesList,
    );
    const { sendRequest: listHeaderFooterTypes } =
      useFetch(getHeaderFooterTypes);

    useEffect(() => {
      const loadPrescriptionTypes = async () => {
        const { data, success } = await listPrescriptionTypes({
          Identifier: 1117,
        });

        if (success && data) {
          setPrescriptionTypes(
            data.map((item) => ({
              id: item.identifierValue,
              code: item.identifierValue,
              name: item.domainValueName,
            })),
          );
        }
      };

      loadPrescriptionTypes();
    }, [listPrescriptionTypes]);

    useEffect(() => {
      const loadHeaderFooterTypes = async () => {
        const { data, success } = await listHeaderFooterTypes(undefined);

        if (success && data) {
          setHeaderFooterTypes(data);

          if (!getValues("headerFooterType")) {
            const defaultType = data.find((item) => item.code === "1");
            if (defaultType) setValue("headerFooterType", defaultType);
          }
        }
      };

      loadHeaderFooterTypes();
    }, [getValues, listHeaderFooterTypes, setValue]);

    return (
      <>
        <Grid item xs={12} sm={6}>
          <AutoCompleteMulti
            name="esignRuleDocExtMedCertTypes"
            label={
              t(translationPath + "external_medical_certificate_types") ||
              "Tipo de receita"
            }
            getOptionLabel={(option) => option.name}
            options={prescriptionTypes}
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item sm={6} sx={{ display: { xs: "none", sm: "block" } }} />

        <Grid item xs={12} sm={6}>
          <AutoComplete
            name="headerFooterType"
            label={
              t(translationPath + "header_footer_type") ||
              "Modelo padrão cabeçalho e rodapé"
            }
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            size="small"
            fullWidth
            clearIcon={false}
            options={headerFooterTypes}
          />
        </Grid>
        <Grid item sm={6} sx={{ display: { xs: "none", sm: "block" } }} />
      </>
    );
  },
);
